// Informations du cabinet : à modifier ici, elles se mettent à jour partout sur le site.
const config = {
  name: 'Fiat Architecte',
  email: 'gefiat-archi@orange.fr', // À VÉRIFIER : une adresse Gmail finit normalement par .com
  phone: '+33 06 09 95 19 81',                        // Ex : '04 93 00 00 00' (laisser vide pour ne rien afficher)
  addressLine: '15 rue Michelet',
  city: 'Nice',
  // Image plein écran de la page d'accueil (dossier public/)
 heroImage: `${process.env.PUBLIC_URL}/imagemesprojets/LR_4.jpg`,
  // Coordonnées de la carte
  lat: 43.714562,
  lng: 7.2597007,
};

export default config;
